import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

/**
 * Submit a lead (contact / quote).
 * @param {Object} payload lead fields
 * @returns {Promise<{success:boolean,id:string,message:string}>}
 */
export async function submitLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}
